import styled from 'styled-components';

import { theme } from 'assets/styles/theme';
import { CurrentUserDto } from 'services/user/userService.dto';

import { UserData } from './UserData';
import { UserName } from './UserName';

const Container = styled.div`
  width: 100%;
  margin-left: 120px;

  ${theme.mq.tablet} {
    margin: 12px 0;
  }
`;

interface UserInfoProps {
  currentUser: CurrentUserDto;
  refreshCurrentUser: () => void;
}

export const UserDetails = ({ currentUser, refreshCurrentUser }: UserInfoProps) => {
  return (
    <Container>
      <UserName currentUser={currentUser} />
      <UserData currentUser={currentUser} refreshCurrentUser={refreshCurrentUser} />
    </Container>
  );
};
